import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Toaster = () => {
    return (
        <>
            <style>
                {`
                    .Toastify__toast .Toastify__toast-icon {
                        margin-right: 12px !important;
                    }
                `}
            </style>
            <ToastContainer 
                position="bottom-center" 
                autoClose={2000} 
                hideProgressBar={true}
                closeOnClick={true}
                pauseOnHover={false}
                draggable={false}
                limit={3}
                toastStyle={{ minWidth: '350px', maxWidth: '700px', width: 'auto', whiteSpace: 'pre-line', wordBreak: 'break-word' }}
            />
        </>
    );
};

const SuccessToast = ({ message }) => (
    <div>
        <div style={{ fontWeight: 'bold', color: '#357a38', fontSize: '1.1em', marginBottom: 2  }}>
            Success
        </div>
        <div style={{ whiteSpace: 'pre-line', wordBreak: 'break-word' }}>{message}</div>
    </div>
);

const getToastId = (type, message) => `${type}-${String(message).trim()}`;

export const showToast = (type, message) => {
    const toastId = getToastId(type, message);

    if (type === 'success') {
        toast.success(<SuccessToast message={message} />, {
            position: "bottom-center",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            toastId
        });
    } else if (type === 'error') {
        toast.error(message, {
            position: "bottom-center",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            toastId
        });
    }
};

export default Toaster;
